import type { AutomationsPlanKey } from "../../models/automations-plans";

/** One factory for every Automations query key, so reads, writes and invalidation cannot drift. */
export const automationsKeys = {
  entitlement: (artistId: string) =>
    ["automationsEntitlement", artistId] as const,
  billing: (artistId: string) => ["automationsBilling", artistId] as const,
  usageAll: (artistId: string) => ["automationsUsage", artistId] as const,
  usage: (artistId: string, since: string | null | undefined) =>
    ["automationsUsage", artistId, since] as const,
  changePreview: (artistId: string, target: AutomationsPlanKey | null) =>
    [
      "automationsChangePreview",
      artistId,
      target?.tier,
      target?.interval,
    ] as const,
  checkoutSessionsAll: (artistId: string) =>
    ["automationsCheckoutSession", artistId] as const,
  checkoutSession: (artistId: string, returnTo: string) =>
    ["automationsCheckoutSession", artistId, returnTo] as const,
  creditBalance: (artistId: string) => ["creditBalance", artistId] as const,
  creditBalanceAll: () => ["creditBalance"] as const,
} as const;
